// extracted by mini-css-extract-plugin
export default {"container":"label_field_container__AI27K"};